<template>
  <span />
</template>

<script>
export default {
  props: {
    value: Object,
    message: String,
  },
  mounted() {
    // console.log(this.props.message, { ...this.props.value })
  },
}
</script>
